import { render, staticRenderFns } from "./AdminDelegating.vue?vue&type=template&id=ae9ce460&"
import script from "./AdminDelegating.vue?vue&type=script&lang=js&"
export * from "./AdminDelegating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports